import React, { useState, useEffect } from 'react'

import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import { Card, Button } from './'

function Pagination({ pageItems = 10, allItems = 100, displayItems = 4, url }) {
    const allPages = allItems / pageItems

    const firstItem = currentPage > 1 ? (currentPage - 1) * pageItems + 1 : 1

    const [currentPage, setCurrentPage] = useState(1)

    const displayArray = (start, stop, step) =>
        Array.from(
            { length: (stop - start) / step + 1 },
            (_, i) => start + i * step
        )

    const [showArray] = useState(displayArray(0, displayItems - 1, 1))

    // const lastCoinExist = () => {
    //     if (firstItem) return '&last_coin_name='
    // }

    const PAGE_URL = [
        url,
        '/v1/latest?step=',
        pageItems,
        '&first_index=',
        firstItem
    ].join('')

    useEffect(() => {
        fetch(PAGE_URL)
            .then((response) => response.json())
            .then(
                (data) => {
                    /*ignore*/ console.log('pagination success', data)
                },
                //bug should use .catch
                (error) => {
                    /*ignore*/ console.log('pagination danger', error)
                }
            )
    }, [PAGE_URL, url])

    return (
        <div className="pt-6 grid xl:grid-cols-3 justify-items-center">
            <Card spacing="md" shadow="md" bordered className="xl:col-start-2">
                <div className="flex justify-center">
                    <Button
                        hoverColor={
                            currentPage <= 1 ? 'transparent' : 'lighter'
                        }
                        onClick={() =>
                            setCurrentPage(
                                currentPage > 1 ? currentPage - 1 : currentPage
                            )
                        }
                        disabled={currentPage <= 1}
                    >
                        <BsArrowRightShort />
                    </Button>

                    {currentPage > 1 && (
                        <Button
                            hoverColor={
                                currentPage === 1 ? 'primary' : 'lighter'
                            }
                            backgroundColor={
                                currentPage === 1 ? 'primary' : 'white'
                            }
                            color={currentPage === 1 ? 'white' : 'text'}
                            className="mx-1"
                            onClick={() => {
                                setCurrentPage(1)
                            }}
                        >
                            1
                        </Button>
                    )}
                    {currentPage > 2 && <span className="mx-1">...</span>}
                    {showArray.map(
                        (item, idx) =>
                            item + currentPage < allPages && (
                                <Button
                                    key={idx}
                                    hoverColor={
                                        item + currentPage === currentPage
                                            ? 'primary'
                                            : 'lighter'
                                    }
                                    onClick={() => {
                                        setCurrentPage(item + currentPage)
                                    }}
                                    backgroundColor={
                                        item + currentPage === currentPage
                                            ? 'primary'
                                            : 'white'
                                    }
                                    color={
                                        item + currentPage === currentPage
                                            ? 'white'
                                            : 'text'
                                    }
                                    className="mx-1"
                                >
                                    {item + currentPage}
                                </Button>
                            )
                    )}

                    {currentPage < allPages - displayItems && (
                        <span className="mx-1">...</span>
                    )}

                    <Button
                        hoverColor={
                            currentPage === allPages ? 'primary' : 'lighter'
                        }
                        backgroundColor={
                            currentPage === allPages ? 'primary' : 'white'
                        }
                        color={currentPage === allPages ? 'white' : 'text'}
                        className="mx-1"
                        onClick={() => {
                            setCurrentPage(allPages)
                        }}
                    >
                        {allPages}
                    </Button>

                    <Button
                        hoverColor={
                            currentPage >= allPages ? 'transparent' : 'lighter'
                        }
                        onClick={() =>
                            setCurrentPage(
                                currentPage < allPages
                                    ? currentPage + 1
                                    : currentPage
                            )
                        }
                        disabled={currentPage >= allPages}
                    >
                        <BsArrowLeftShort />
                    </Button>
                </div>
            </Card>
        </div>
    )
}

export default Pagination
